/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 * * `list` - LIST
 * * `board` - BOARD
 * * `calendar` - CALENDAR
 * * `roadmap` - ROADMAP
 * * `workflow` - WORKFLOW
 */
export enum LayoutKind {
  LIST = 'list',
  BOARD = 'board',
  CALENDAR = 'calendar',
  ROADMAP = 'roadmap',
  WORKFLOW = 'workflow',
}
